// @flow
import * as React from 'react';
import { Link } from 'react-router-dom';

type Props = {
  absolute: boolean,
  href: string,
  children: React.Node
};

const AbsoluteLinkWrapper = (props: Props) =>
  props.absolute ? (
    <a className="AbsoluteLinkWrapper" href={props.href}>
      {props.children}
    </a>
  ) : (
    <Link to={props.href}>{props.children}</Link>
  );

export default AbsoluteLinkWrapper;



// WEBPACK FOOTER //
// ./src/components/AbsoluteLinkWrapper.jsx